import { unsubLinks, unsubscribeText } from '../constants/constants';
import { config } from '../constants/domainConfig';
import { sendData } from '../analytics/sendData'

export const onUnsubClick = (e) => {
    e.preventDefault();
    const uid = JSON.parse(sessionStorage.getItem('authorized')) ? JSON.parse(sessionStorage.getItem('authorized')).uid : '';
    sendData('', '', 'video', 'unsubscribe clicked');
    const staging = sessionStorage.getItem("staging") === "true" || sessionStorage.getItem("staging") === "1"
    if(staging){
        if(config.domain === "za"){
            window.open(`http://ads-za-yola.sam-media.com/unsubscribe/za1?country=eg&lang=eg&token=${uid}`)
        }
        else if(config.domain === "be"){
            window.open(`http://staging-prox.vidzmapping.be/unsubscribe/be/?country=be&domain=be.mobio360.com&token=${uid}`)
        }
    }
    if (unsubLinks[config.domain]){
        const unsubUrl = new URL(unsubLinks[config.domain])
        
        if(config.lang === "be") unsubUrl.searchParams.append("lang", "nl");
        else if(config.domain === 'sa') unsubUrl.searchParams.append("lang", "en");
        else unsubUrl.searchParams.append("lang", config.lang);

        unsubUrl.searchParams.append("token", uid);
        window.open(unsubUrl.href)
    }
}

export const unsubscribeTextFun =()=>{
    if(unsubscribeText[config.domain]){
        const unsubText = unsubscribeText[config.domain]
        return unsubText;
    }
}


// WEBPACK FOOTER //
// ./src/utils/unsubHelper.js